/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: `RXq-8T98Sv0`,
    title: `The New DJI Mavic 3 Cine – 5.1K Dual camera OVERHAUL!!`,
    description: `In this video we get our hands on the new DJI Mavic 3 Cine Premium Combo drone. If you are a cinematographer and are looking for a portable drone with all the features to help you capture the shot and remove some human error, this is it. Equipped with a dual-camera system featuring a Hasselblad 4/3 CMOS camera with 12.8 stops of dynamic range and a 28x zoom lens. The battery life has now been enhanced to deliver a flight time of up to 46 minutes, so with all 3 batteries that is over two hours of total flight time! The DJI Mavic 3 Cine also supports 10-bit D-log and is capable of shooting in 5.1K/50fps Apple ProRes 422HQ and even has a 1TB built-in SSD which is so convenient for when you go to fly and realize you forgot to bring a memory card – I can’t be the only one who has done this. Finally, I am very excited to try out all the intelligent features that are coming like: Hyperlapse, Mastershots, FocusTrack, QuickShots, Panorama as well as 4K/120fps and 4G transmission capability which will all be available through a firmware update in January 2022.`,
    tags: [`drones`, `DJI`, `aerial shot`],
    creator: `Peter McKinnon`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLTiuod_B0mbJZ5tOv03xVVbi3dNVfT7yHJTgdugrg=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `ux5Sto7-8JY`,
    title: `The SECRET To FILMING a SOLO CINEMATIC B ROLL - Full BTS Walkthrough`,
    description: `In this video I show you the secrets to filming yourself alone and creating a cinematic B roll video.`,
    tags: [`b roll`, `cinematic`],
    creator: `Sean Kitching`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLQI8b9FkTxpN9IMRkYhqUIyJ5zoAZ02CqXZT7JS=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `P73KIWU1hbs`,
    title: `5 MISTAKES to AVOID in Product Photography!!`,
    description: ``,
    tags: [`photography`, `lens`, `lenses`, `product photography`],
    creator: `Peter McKinnon`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLTiuod_B0mbJZ5tOv03xVVbi3dNVfT7yHJTgdugrg=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `yTAG5uSzwlM`,
    title: `The Art of Sound Design`,
    description: `I am hopeful that this video will inspire someone to try to better themselves in this craft as well! Thank you for the inspiration, Sam Kolder and Cee Roo!`,
    tags: [`sound design`, `sam kolder`],
    creator: `DreamDuo Films`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLRs2f9Ef-q7Bejumxyn9YBjZrebWezdEw8D6akX=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `f8XOxLeVg5s`,
    title: `How I Filmed a Big Budget Commercial (On a Phone...)`,
    description: `100% shot on the OnePlus 9 Pro. It was so freeing to take on a project like this with nothing but a few phones and the intention of having a good time with friends. Thats why I think this turned out to be one of my favourite videos to date. :)`,
    tags: [
      `phone cinematography`,
      `mobile cinematogaphy`,
      `mobile`,
      `sam kolder`,
      `phone`,
      `cinematic`,
    ],
    creator: `kold`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLTMP27nibIu7zzXID9R3m8HoCjjf4wbJW60DAVqfg=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `USqPCNu3Llw`,
    title: `NATURAL LIGHT BEACH PORTRAIT PHOTOSHOOT (SONY A7RIV)`,
    description: ``,
    tags: [`photography`, `lens`, `lenses`, `natural light`, `sony`],
    creator: `Lizzie Peirce`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLQ9dJ-XyOSgW7tKL18sVm42DbWLAn0eOV92pcto3g=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `JtOMlDLxEy0`,
    title: `Magic of India | Cinematic Video`,
    description: `It was our first time in India, a place that had always been high on my list. Erik, Vunkki and I arrived just in time to experience the colourful celebrations of holi, where coloured starch powder is thrown, with water throwing and many other prank like activities that take place on every street. We had the experience of a lifetime getting involved in the celebrations and being covered in colours. Unfortunately due to the restrictions of the COVID19 virus covering the globe, we had to leave India early to go back to our homes. We planned to visit many more places North and South, however we could only stay for 10 days, and in that time we visited Delhi, Vrindivan, Mathura, Orcha, Agra, and Varanasi. However even though we didn't see all of India's amazing locations, it gives us a great reason to come back again!`,
    tags: [`india`, `cinematic`, `holi`, `transition`, `cinematic video`],
    creator: `Benn TK`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLSBQTqYhSUVCb5fl92Mdo4a4nMJKvVLjRIQDmLgCA=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `CpE8Xdv9GF0`,
    title: `SOUND DESIGN For FILMMAKING! | Breakdown Of Epic Motocross Commercial`,
    description: `About a week ago I had the chance to film a professional motocross driver and decided to create an epic 1 minute video with 200FPS slow motion, 360 onboard perspectives and dope FPV drone shots. As my friends over at Artlist are currently running their SFX Challenge, I focused a lot on the sound design in order to show you my workflow and break down how you can improve the audio side of your own videos!`,
    tags: [`sound design`, `edit breakdown`],
    creator: `Niklas Christl`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLRr0vn-bwR_uY_u5_xGEPtW3v8ZqZhoyMkOkUww=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `WbBlm1ryc6I`,
    title: `Best Lenses for Travel Photography | Sony Lens Guide ft. Allison Anderson`,
    description: `Learn about great lens options & focal lengths for travel photography with travel creator and Sony Alpha ambassador Allison Anderson. Watch the video to see her go-to Sony lenses.`,
    tags: [`photography`, `lens`, `lenses`, `sony`, `travel photography`],
    creator: `Sony I Alpha Universe`,
    creatorAvatar: `https://yt3.ggpht.com/b5YjRslp9uuOrImigs7jGN1fup0jxL0HFJGgFy3e3EnHsLQjuDCFsg4HyWasVP8bV_gyOmi4yXU=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `th9pG9Q6Kuo`,
    title: `Joker Cinematographer Explains The Impact of Color in Film | Vanity Fair`,
    description: `"Joker" cinematographer Lawrence Sher explains the impact color has on film. Using several of his films as examples, including "The Hangover," "Garden State," and "Paul." Sher explains how hue, saturation, and light affect the mood, style, and story of a film. `,
    tags: [`cinematography`, `colors`, `joker`],
    creator: `Vanity Fair`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLSIwHw2SiK-_2WwSeAkSd0eJm4Q6JHDUqbV5bCPp-8=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `h2c9fwbeurM`,
    title: `HOW TO SPEED RAMP TRANSITION / CAR EDIT - FINAL CUT PRO`,
    description: `Car edit speed ramping tutorial in Final Cut Pro`,
    tags: [
      `video editing`,
      `speed ramp`,
      `final cut pro`,
      `fcpx`,
      `transition`,
      `editing`,
    ],
    creator: `RyanNangle`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLT9Fcq0uUKEnfzzgT05tDviRwudQ5gvqDEXNJTDhQ=s176-c-k-c0x00ffffff-no-rj`,
  },
  {
    _id: `0suVZjz3_Uw`,
    title: `8 Steps to Cinematic Lighting | Tomorrow's Filmmakers`,
    description: ``,
    tags: [`lighting`, `cinematic lighting`],
    creator: `Tomorrows Filmmakers`,
    creatorAvatar: `https://yt3.ggpht.com/ytc/AKedOLSnryUvPaQBsSeGW8V8GKH62LKKaPl-jVOwxHRFpg=s176-c-k-c0x00ffffff-no-rj`,
  },
];
